// extracted by css-extract-rspack-plugin
export default {"CommitSelectorWrapper":"CommitSelector-module__CommitSelectorWrapper__Eddz8","CommitSelectorContainer":"CommitSelector-module__CommitSelectorContainer__wyDem"};